// **  Initial State
const initialState = {
    activeTenant: null,
    loading: false,
    error: null
}

const tenantReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_TENANT_REQUEST':
            return { ...state, loading: true }
        case 'GET_TENANT_SUCCESS':
            return {
                ...state,
                loading: false,
                activeTenant: action.data,
                error: null
            }
        case 'GET_TENANT_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.error
            }
        case 'UPDATE_TENANT_SUCCESS':
            return {
                ...state,
                activeTenant: { ...state.activeTenant, ...action.data }
            }
        default:
            return state
    }
}

export default tenantReducer
